import React from "react";
import {
  FiHome,
  FiLayers,
  FiGrid,
  FiCpu,
  FiLogOut,
} from "react-icons/fi"; // Feather icons
import "./Cuspage.css";

const Cuspage = () => {
  const access = localStorage.getItem("accessToken");

  const backendurl =
    window.location.hostname === "localhost"
      ? ""
      : window.location.hostname === "demo.ollinwon.com"
      ? process.env.REACT_APP_BACKEND_URL
      : window.location.hostname === "iot.aizoteq.com"
      ? process.env.REACT_APP_BACKEND_URL2
      : "";

  const handlelogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("authToken");
    window.location.href = "/";
  };

  // Sample JSON (replace with API fetch later if needed)
  const data = {
    total_count: 50,
    total_pages: 5,
    page: 2,
    limit: 10,
    total_homes: 2,
    homes: [
      {
        home_id: 1,
        home_name: "Main Home",
        floors: [
          {
            floor_id: 101,
            floor_name: "Ground Floor",
            rooms: [
              {
                room_id: 1001,
                room_name: "Living Room",
                device_count: 3,
              },
            ],
          },
        ],
      },
    ],
  };

  return (
    <div className="cus-main">
      {/* ✅ Navbar */}
      <nav className="cus-navbar">
        <h2 className="nav-title">Dashboard</h2>
        <button className="logout-btn" onClick={handlelogout}>
          <FiLogOut /> Logout
        </button>
      </nav>

      {/* <h1>Your Unauthorized</h1>
      <h3>Please logout</h3> */}

      {/* ✅ Homes List */}
      <div className="homes-container">
        {data.homes.map((home) => (
          <div key={home.home_id} className="home-card">
            <h2>
              <FiHome /> {home.home_name}
            </h2>

            {home.floors.map((floor) => (
              <div key={floor.floor_id} className="floor-card">
                <h3>
                  <FiLayers /> {floor.floor_name}
                </h3>

                {floor.rooms.map((room) => (
                  <div key={room.room_id} className="room-card">
                    <p>
                      <FiGrid /> {room.room_name}{" "}
                      <span className="device-count">
                        <FiCpu /> {room.device_count} Devices
                      </span>
                    </p>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Cuspage;
